<template>
  <div>
<vs-table v-if="show" ref="table" :params="params" :options="options"></vs-table>

  <span>
      dsladkk
      <i class="icon-account-card-details"></i>
      <i class="icon-bank"></i>
      <i class="icon-file-document-box-multiple-outline"></i>
      <i class="icon-sort-descending"></i>
      <i class="icon-baseline-https-24px"></i>
      <i class="icon-baseline-perm_identity-24px"></i>
      <i class="icon-dropbox"></i>
      <i class="icon-ruler"></i>
      <i class="icon-account-edit"></i>
      <i class="icon-account-multiple"></i>
      <i class="icon-book-plus"></i>
      <i class="icon-bulletin-board"></i>
      <i class="icon-calendar-blank-outline"></i>
      <i class="icon-calendar-edit"></i>
      <i class="icon-cart"></i>
      <i class="icon-cart-plus"></i>
      <i class="icon-check"></i>
      <i class="icon-checkbox-marked-circle-outline"></i>
      <i class="icon-check-circle-outline"></i>
      <i class="icon-close-circle-outline"></i>
      <i class="icon-content-duplicate"></i>
      <i class="icon-delete-empty"></i>
      <i class="icon-domain"></i>
      <i class="icon-eye-outline"></i>
      <i class="icon-file-document"></i>
      <i class="icon-file-document-box-multiple"></i>
      <i class="icon-office-building"></i>
      <i class="icon-paperclip"></i>
      <i class="icon-pencil"></i>
      <i class="icon-plus-circle-outline"></i>
      <i class="icon-shield-key-outline"></i>
      <i class="icon-star-circle"></i>
      <i class="icon-bd-edit"></i>
      <i class="icon-bd-user"></i>
      <i class="icon-bd-book-plus"></i>
      <i class="icon-bd-accept"></i>
      <i class="icon-bd-check"></i>
      <i class="icon-bd-close"></i>
      <i class="icon-bd-delete"></i>
      <i class="icon-desktop-mac-dashboard"></i>
      <i class="icon-bd-domain"></i>
      <i class="icon-bd-document"></i>
      <i class="icon-bd-document-box-multiple"></i>
      <i class="icon-google-analytics"></i>
      <i class="icon-bd-building"></i>
      <i class="icon-bd-pencil"></i>
      <i class="icon-bd-plus"></i>
      <i class="icon-bd-star-circle"></i>
      <i class="icon-wrench"></i>
      <i class="icon-google-analytics"></i>
      <i class="icon-settings"></i>
      <i class="icon-share"></i>

    </span>
  </div>
</template>

<script>
  import VsTable from "../_framework/VsTable.vue";
  import EventBus from "../_framework/bus.js";
export default {
  name: "banks",
  created: () => {},
  components: {
    VsTable
  },
  data() {
    return {
      access: {},
      show: true,
      params: {
        entity: "banks",
        list: [],
        headers: {
          name: {
            title: "نام بانک",
            type: "text"
          },
          logo: {
            title: "لوگو",
            type: "custom",
            component: "table-row-image",
            grow: 2,
            // flex: 1,
            rowAlignment: "center"
          },
          code: {
            title: "کد حسابداری",
            type: "text",
             inHeader: true
          },
                  }
      },
      options: {
        hasActions: true,
        hasActionsInHeader: true
      }
    };
  },
  mounted() {
    EventBus.$on("onResetRowMode", () => {
      this.refreshTable();
      // this.show = false;
      // setTimeout(() => {
      //   this.show = true;
      // }, 50);
    });
  },
  beforeMount() {
    this.options.access = checkAccess(this.$route.path);
    //console.log(this.options.access);
    this.show = this.options.access ? true : false;
  },
  methods: {
    refreshTable() {
      this.show = false;
      setTimeout(() => {
        this.show = true;
      }, 1000);
      // this.$refs.table.onFetchEntityList();
    }
  }
};
</script>
